interface TimeZoneProps {
  [key: string]: string
}

export interface RevisarDadosFormData {
  identidade: {
    razaoSocial: string;
    nomeFantasia: string;
    cnpjcpf: string;
  };
  endereco: {
    logradouro: string;
    numero: string;
    bairro: string;
    complemento: string;
    municipio: string;
    uf: string;
    cep: string;
  };
  dadosInternet: {
    email: string;
  };
  responsavelEmpresa: {
    nome: string;
    cpf: string;
    telefoneFixo: string;
    telefoneCelular: string;
    email: string;
    senha: string;
  };
  contratos: {
    qtdeConexoes: number;
  };
}

export function gerarPayload(formData: RevisarDadosFormData, codigo: string) {
    return {
      codigo,
      razaoSocial: formData.identidade.razaoSocial,
      nome: formData.identidade.nomeFantasia,
      nomeFantasia: formData.identidade.nomeFantasia,
      cpfCnpj: formData.identidade.cnpjcpf,
      email: formData.dadosInternet.email,
      logradouro: formData.endereco.logradouro,
      numero: formData.endereco.numero,
      bairro: formData.endereco.bairro,
      complemento: formData.endereco.complemento,
      municipio: formData.endereco.municipio,
      uf: formData.endereco.uf,
      cep: formData.endereco.cep,
      inscricaoEstadual:'',
      inscricaoMunicipal:'',
      creci:'',
      site:'',
      telefoneAlternativo:'',
      telefoneFixo: formData.responsavelEmpresa.telefoneFixo,
      usuarioNome: formData.responsavelEmpresa.nome,
      usuarioEmail: formData.responsavelEmpresa.email,
      usuarioSenha: formData.responsavelEmpresa.senha,
      usuarioCelular: formData.responsavelEmpresa.telefoneCelular,
      usuarioCpf: formData.responsavelEmpresa.cpf,
      maximoSessoes: formData.contratos.qtdeConexoes,
      timeZone: timezones[formData.endereco.uf],
      timeoutSessao: 120
    }
}

const timezones: TimeZoneProps = {
  'AC':'America/Rio_Branco',
  'AL':'America/Maceio',
  'AP':'America/Belem',
  'AM':'America/Manaus',
  'BA':'America/Bahia',
  'CE':'America/Fortaleza',
  'DF':'America/Sao_Paulo',
  'ES':'America/Sao_Paulo',
  'GO':'America/Sao_Paulo',
  'MA':'America/Fortaleza',
  'MT':'America/Cuiaba',
  'MS':'America/Campo_Grande',
  'MG':'America/Sao_Paulo',
  'PR':'America/Sao_Paulo',
  'PB':'America/Fortaleza',
  'PA':'America/Belem',
  'PE':'America/Recife',
  'PI':'America/Fortaleza',
  'RJ':'America/Sao_Paulo',
  'RN':'America/Fortaleza',
  'RS':'America/Sao_Paulo',
  'RO':'America/Porto_Velho',
  'RR':'America/Boa_Vista',
  'SC':'America/Sao_Paulo',
  'SE':'America/Maceio',
  'SP':'America/Sao_Paulo',
  'TO':'America/Araguaia'
}